import React from 'react'
import CustomAppBar from '../components/CustomAppBar'
import Navbar from '../components/Navbar';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

import AppContainer from '../components/AppContainer'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Image from 'mui-image';
import SectionBanner2 from '../components/SectionBanner2';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TextContainer from '../components/TextContainer';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PrimaryButton from '../components/PrimaryButton';

// Create a Frequestly Asked Questions object to store the questions and answers
const FAQData = [
    {
        question: "How can I connect my Lumas heart to my account?",
        answer: (
            <>
              <Typography variant='body2'>
              To add your heart to your account, click on the blue "+" button next to 'Hearts' on the Home page. From there, there are 2 methods to add the heart.
              </Typography>
              <Typography variant='body2' sx={{marginTop: '15px'}}>
              <strong>Option 1:</strong> hearts connected to the same WiFi network will automatically populate in the 'Nearby Hearts' section. Simply click the desired heart listed under 'Nearby Hearts' to add it to your account.
              </Typography>
              <Typography variant='body2' sx={{marginTop: '15px'}}>
              <strong>Option 2:</strong> hearts can be added by manually entering the heart's unique MAC address, then clicking 'Add Heart'. Further instructions on where to find your MAC address can be found on the Add New Heart page.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/AddNewHeart.png" width={300} />
              </Box>
            </>
        )
    },
    {
        question: "How do I create a group?",
        answer: (
            <>
              <Typography variant='body2'>
              To create a group, click on the blue "+" button next to 'Groups' on the Home page. From there, click on the 'Create New Group' button and follow the prompts to create the group.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/createGroup.png" width={300} />
              </Box>
            </>
        )
    },
    {
        question: "How do I join a group?",
        answer: (
            <>
              <Typography variant='body2'>
                To join a group, click on the blue "+" button next to 'Groups' on the Home page. From there, click on the 'Join Group' button then enter the Group ID of the group you wish to join, then click 'Join Group'.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/JoinGroup.png" width={300} />
              </Box>
            </>
        )
    },
    {
        question: "Where can I find the Group ID needed for others to join my group?",
        answer: (
            <>
              <Typography variant='body2'>
                After creating a group, you may view group details by clicking the gear icon in the upper-right corner of the group on the home page. 
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/OpenManageGroup.png" width={300} />
              </Box>
              <Typography variant='body2'>
                Once on the group page, click on the 'Copy Group ID' button. Share the group ID with the people you want to add to your group. They may then join your group by entering the same group ID on the Join Groups page.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/copyGroupID.png" width={300} />
              </Box>
            </>
        )
    },
    {
        question: "I added my heart to my account. How can I connect it to other people's hearts?",
        answer: "To connect your heart to other people's hearts, you must add it to a group. Hearts only communicate to other hearts in their group. You can add a heart to a group by clicking on the blue 'Add to Group' button below your heart on the Home page."
    },
    {
        question: "How can I add my heart to a group?",
        answer: (
            <>
              <Typography variant='body2'>
                On the home page, click on the blue 'Add to Group' button below your heart.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/AddHeartToGroup.png" width={300} />
              </Box>
              <Typography variant='body2' sx={{marginTop: '15px'}}>
                Then select the group you would like to add your heart to among the list of your current groups. If you are not yet part of a group, you may select the 'add a group' button.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/AddHeartToGroup2.png" width={300} />
              </Box>
            </>
        )
    },
    {
        question: "What is the maximum number of hearts that can be added to a single group?",
        answer: (
            <>
              <Typography variant='body2'>
                Currently, our system supports a maximum of 20 Lumas devices in a single group. However, if you need a larger group size, please email us at <a href='mailto:support@lumas.live'>support@lumas.live</a> and we'd be happy to discuss options!
              </Typography>
            </>
        )
    },
    {
        question: "How do I change the color of a heart?",
        answer: (
            <>
              <Typography variant='body2'>
                To change the color, your heart must first be part of a group. Once added to a group, simply click the large heart icon of the heart you would like to change color. 
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/ChangeColor.png" width={300} />
              </Box>
              <Typography variant='body2'>
                A popup will appear with a color slider. Slide the slider to the desired color then click 'save' to update the color.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/ChangeColor2.png" width={300} />
              </Box>
            </>
        )
        
    },
    // {
    //     question: "How can I change the group my heart?",
    //     answer: "First navigate to the manage heart page by clicking the gear icon in the upper-right side of the "
    // },
    {
        question: "How do I change my password?",
        answer: (
            <>
                <Typography variant='body2'>
                    To change your password, first sign out of your account. Once on the Lumas sign-in page, click 'Log In' then select the 'Forgot Password?' link.
                </Typography>
                <Box sx={{display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px'}}>
                    <Image src="https://heartappimages.s3.us-west-2.amazonaws.com/forgotPassword.png" width={300} />
                </Box>
                <Typography variant='body2'>
                    You may then enter your email associated with your account to send a password reset email with instructions to reset your password.
                </Typography>
            </>
        )
    },
    {
        question: "How do I change my username?",
        answer: "Unfortunately, usernames cannot be changed at this time. To change your username, you will need to create a new account with a different username."
    },
    {
        question: "How do I delete my account?",
        answer: "Unfortunately, accounts cannot be deleted from the web app at this time. However, you may contact support at the email address below and request we delete your account for you."
    }
]

function FAQ() {


    return (
        <AppContainer>
            <CustomAppBar />
            <Navbar title={"Help and Support"} backButton />
            <SectionBanner2 text={"Lumas Manual"} IconComponent={MenuBookIcon} customStyles={{marginTop: '20px', marginBottom: '10px'}}/>
            <TextContainer>
              {/* <Typography sx={{fontSize: '14px'}}>
                Click here for the Lumas Manual!
              </Typography> */}
              <Button variant="contained" color="primary" href='https://lumas.live/manual' target="_blank">Click Here</Button>
            </TextContainer>
            {/* <SectionBanner2 text={"Frequently Asked Questions"} IconComponent={HelpOutlineIcon} customStyles={{marginTop: '10px', marginBottom: '10px'}}/> */}
            {/* <TextContainer> */}
                {/* Loop through each FAQ from FAQData and create an accordion */}
                {/* {FAQData.map((faq, index) => (
                    <Accordion key={index} disableGutters elevation={0}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                            // sx={{backgroundColor: '#f0f0f0'}}
                        >
                        <Typography sx={{fontWeight: '500', fontSize: '14px'}}>
                            {faq.question}
                        </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        {faq.answer}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </TextContainer> */}
            <SectionBanner2 text={"Support Contact"} IconComponent={SupportAgentIcon} customStyles={{marginTop: '20px', marginBottom: '10px'}}/>
            <TextContainer>
                <Typography variant='body2' mt={1.2} mb={5}>For additional assistance, please contact us at <Link to="mailto:support@lumas.live">support@lumas.live</Link></Typography>
            </TextContainer>
        </AppContainer>
    )
}

export default FAQ